import { render, staticRenderFns } from "./LiftPointPopup.vue?vue&type=template&id=6d1085c0&scoped=true"
import script from "./LiftPointPopup.vue?vue&type=script&lang=js"
export * from "./LiftPointPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1085c0",
  null
  
)

export default component.exports